import React from 'react';

const About = (props) => {
    return (<div>About page</div>);
}
export default About;